import React, { useState } from 'react';
import { cx } from '../cx';

// D-09 §15.25 — Accordion (.acc > .acc-item[.open] > .acc-head > .ar, .acc-panel)
export interface AccordionItem {
  title: React.ReactNode;
  content: React.ReactNode;
}
export interface AccordionProps extends React.HTMLAttributes<HTMLDivElement> {
  items: AccordionItem[];
  defaultOpen?: number[];
}

export function Accordion({ items, defaultOpen = [], className = '', ...props }: AccordionProps) {
  const [open, setOpen] = useState<Set<number>>(() => new Set(defaultOpen));
  const toggle = (i: number) =>
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });

  return (
    <div className={cx('acc', className)} {...props}>
      {items.map((it, i) => (
        <div key={i} className={cx('acc-item', open.has(i) && 'open')}>
          <button type="button" className="acc-head" onClick={() => toggle(i)}>
            {it.title} <span className="ar">▾</span>
          </button>
          <div className="acc-panel">{it.content}</div>
        </div>
      ))}
    </div>
  );
}
